import React from 'react';
import { Col, Form, Input, Row } from 'antd';
import { useIntl } from 'react-intl';
import { Settings } from 'CoreApi.Settings_V12';
import { Address } from 'Common/types';
import withLoading from 'Common/HOC/loadingOr';
import BaseInformationForm from './BaseInformationForm';
import { renderValidationMarkCol } from '../utils';

export interface FormValues {
  tax_number?: string;
  vat_number?: string;
  billing_address: Omit<Address, 'id' | 'title'>;
  country: string | null;
}

interface Props {
  settings: Settings | undefined;
  saveSettings: (values: FormValues) => void;
  showPrevious?: boolean;
  goBack?: () => void;
}
const getValidations = (s: FormValues) => ({
  companyNameValidated:
    Boolean(s?.billing_address?.company) &&
    (s?.billing_address?.company?.length ?? 0) >= 3,
  streetAddressValidated: Boolean(s?.billing_address?.address1),
  cityValidated: Boolean(
    s?.billing_address?.city && s?.billing_address?.zipcode
  ),
  taxInfoValidated: Boolean(s?.vat_number || s?.tax_number),
});
const CheckAccountInformationForm: React.FC<Props> = (props) => {
  const intl = useIntl();
  return (
    <BaseInformationForm
      {...props}
      formName="billing_address"
      getValidations={getValidations}
      additionalFields={
        <Row>
          <Col span="11">
            <Form.Item
              name="tax_number"
              label={intl.formatMessage({ defaultMessage: 'Tax ID' })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    defaultMessage: 'Tax ID is required',
                  }),
                },
                {
                  pattern:
                    /^\d{5}\/\d{5}$|^\d{3}\/\d{3}\/\d{5}$|^\d{2}\/\d{3}\/\d{5}$|^\d{10}$|^\d{11}$|^\d{3}\/\d{4}\/\d{4}$/,
                  message: intl.formatMessage({
                    defaultMessage: 'Tax ID should contain 10 or 11 digits',
                  }),
                },
              ]}
            >
              <Input
                placeholder={intl.formatMessage({
                  defaultMessage: '123/456/7890',
                  description: 'Only tax id placeholder',
                })}
              />
            </Form.Item>
          </Col>
          <Col span="11">
            <Form.Item
              name="vat_number"
              label={intl.formatMessage({ defaultMessage: 'VAT ID' })}
            >
              <Input
                placeholder={intl.formatMessage({
                  defaultMessage: 'DE 123/456/789',
                  description: 'Only vat-id placeholder',
                })}
              />
            </Form.Item>
          </Col>
          {renderValidationMarkCol(
            getValidations(props.settings as FormValues).taxInfoValidated,
            38
          )}
        </Row>
      }
    />
  );
};

export default withLoading<Props & { children: React.ReactNode }>(
  CheckAccountInformationForm
);
